import Vue from "vue";
window.Vue = Vue;
Vue.config.silent = true;
import "@mdi/font/css/materialdesignicons.css";
import "@nuskin/ns-core-styles/src/dist/main.css";

import ProductCard from "./components/ProductCard.vue";
import ProductCardsCarousel from "./components/ProductCardsCarousel.vue";
import ProductList from "./components/ProductList.vue";

export { ProductCard, ProductCardsCarousel, ProductList };
